export default "__VITE_ASSET__ed205420__"